// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/RouteInfoBox/route-info-box.scss
// module id = 72
// module chunks = 0